var Reverb = window.Reverb || {};

// Reverb.CurrencyExchange is used with forms containing an input for a monetary amount that
// will be exchanged to a different currency (for example a form to make an offer on a listing).
//
// When a monetary input changes, it triggers an ajax request which converts the amounts to a
// different currency and renders an HTML fragment response which is rendered into the form.
//
// Example:
//
//   = form_tag some_path, data: { 'currency-exchange-view' => true, 'currency-exchange-url' => '/currency_exchange_url' } do
//     = input_tag :price, nil, data: { 'currency-exchange-input' => 'amount' }
//     = input_tag :shipping, nil, data { 'currency-exchange-input' => 'shipping' }
//     %div.results{ data: 'currency-exchange-approximation' }
//
// When the value of '#price' or '#shipping' changes, an ajax request is sent to
// GET '/currency_exchange_url?amount=<amount>&price=<price>' and the response is rendered in '.results'.
//
Reverb.CurrencyExchange = (function () {
  var doneTypingTimeout = 800, // ms
    viewSelector = '[data-currency-exchange-view]',
    inputSelector = '[data-currency-exchange-input]',
    approximationSelector = '[data-currency-exchange-approximation]';

  function init() {
    $(approximationSelector).hide();

    Reverb.Forms.doneTyping(inputSelector, doneTypingTimeout, amountChanged);
  }

  function amountChanged(event) {
    var $view = $(event.target).closest(viewSelector),
      $approximation = $view.find(approximationSelector);

    if (shouldConvertCurrency($view)) {
      $approximation.show();
      $approximation.spin();

      fetchApproximation($view);
    }
  }

  // Allows the view to be initialized using 'data-convert-currency' (no value)
  // or 'data-convert-currency="true"', but not 'data-convert-currency="false"'
  function shouldConvertCurrency($view) {
    return $view.data('currency-exchange-view') !== false;
  }

  function fetchApproximation($view) {
    var $inputs = $view.find(inputSelector),
      $approximation = $view.find(approximationSelector),
      currencyExchangeUrl = $view.data('currency-exchange-url'),
      params = {};

    $.each($inputs, function (index, input) {
      var $input = $(input);
      params[$input.data('currency-exchange-input')] = $input.val();
    });

    $.ajax({
      type: 'GET',
      url: currencyExchangeUrl,
      data: params
    }).then(function (response) {
      $approximation.html(response);
      initTips($approximation);
    });
  }

  return {
    init: init
  };
})();

$(function () { Reverb.CurrencyExchange.init(); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/currency_exchange.js